<template>
  <v-dialog :value="value" persistent max-width="800px">
    <v-form v-if="value" v-model="formValid" ref="form">
      <v-card>
        <v-subheader class="primary headline white--text" style="width: 100%">{{
          $t("common.newEvent")
        }}</v-subheader>
        <v-card-text class="px-7">
          <DragAndDrop
            :title="this.$t('itinerary.NewEvent.ddTitle')"
            v-on:update:file="image = $event"
            :initial="currentImage"
            @imagepath="recycledImagePath = $event"
          />
          <v-text-field
            v-model="newEvent.name"
            :label="$t('common.name')"
            required
            :rules="[rules.required]"
            prepend-icon="mdi-pencil"
          ></v-text-field>
          <div style="height: 200px; border: 1px solid #ccc !important; border-radius: 12px">
            <quill-editor
              class="editor"
              ref="myQuillEditor"
              :options="editorOption"
              @ready="onEditorReady"
            />
          </div>
          <v-card v-if="savedPDF || pdf" class="py-auto text-right mt-4 pt-1" max-width="200px">
            <v-btn icon @click="clearPDF"><v-icon>mdi-close</v-icon></v-btn>
            <v-img
              class="mx-auto"
              width="100px"
              height="100px"
              contain
              :src="require('@/assets/pdf.png')"
            >
            </v-img>
            <h4 class="mt-3 mx-auto py-2 text-center grey lighten-2">
              {{ pdf != null ? pdf.name : savedPDF }}
            </h4>
          </v-card>
          <input
            type="file"
            multiple
            style="display: none"
            ref="pdf"
            accept="application/pdf"
            @change="onPDFPicked"
          />
          <v-btn class="mt-4" tile text color="primary" @click="$refs.pdf.click()">
            <v-icon left>mdi-file-pdf-box</v-icon>
            {{ $t("common.pdf") }}
          </v-btn>
          <div v-if="!hotel" class="d-flex flex-row align-center mt-4">
            <v-icon>mdi-grid-large </v-icon>
            <h4 class="mx-4">{{ $t("itinerary.NewEvent.eventType") }}</h4>
            <v-btn-toggle
              v-model="isRemote"
              persistent-hint
              mandatory
              dense
              rounded
              color="primary"
              :hint="
                $t(`itinerary.NewEvent.${isRemote ? 'remoteEventHint' : 'presentialEventHint'}`)
              "
            >
              <v-btn :disabled="editEvent != null" :value="false">{{
                $t("itinerary.NewEvent.presentialEvent")
              }}</v-btn>
              <v-btn :disabled="editEvent != null" :value="true">{{
                $t("itinerary.NewEvent.remoteEvent")
              }}</v-btn>
            </v-btn-toggle>
          </div>
          <div v-if="!isRemote" class="d-flex flex-row align-center mt-4">
            <v-icon>mdi-map-marker</v-icon>
            <h4 class="mx-4 mt-2">{{ $t("itinerary.NewEvent.eventLocation") }}</h4>
            <!-- <v-btn class="primary" small> set </v-btn> -->
            <v-text-field v-model="newEvent.location.name" placeholder="Name"></v-text-field>
            <!-- :value="newEvent.location.city" -->
            <v-select
              class="ml-4"
              :items="cities"
              v-model="city"
              v-show="!newEvent.location.coordinates"
              :disabled="city != null && newEvent.location.coordinates != null"
              label="City"
              style="max-width: 200px"
              item-text="id"
              return-object
              @change="cityChanged"
            ></v-select>
            <!-- :placeholder="$t('common.location')" -->
            <v-text-field
              class="ml-4"
              :value="newEvent.location.address"
              readonly
              placeholder="Address"
              append-icon="mdi-pencil"
              @click="mapDialog = true"
              @click:append="mapDialog = true"
            ></v-text-field>

            <v-dialog v-model="mapDialog" width="600">
              <!-- <template v-slot:activator="{ on }">
                <v-btn small text color="primary" v-on="on">
                  <v-icon left>mdi-pencil</v-icon>
                  {{ $t("common.edit") }}
                </v-btn>
              </template> -->
              <v-card v-if="mapDialog">
                <div class="primary">
                  <v-btn
                    class="float-right mr-2 mt-1"
                    icon
                    color="white"
                    text
                    @click="mapDialog = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <p v-if="marker && marker.address" class="white--text pa-2 ma-0 text-center">
                    {{ marker.address }}
                  </p>
                </div>
                <MglMap
                  v-if="mapDialog"
                  :accessToken="accessToken"
                  :center.sync="mapCenter"
                  :zoom.sync="mapZoom"
                  style="width: 600px; height: 400px"
                  :mapStyle="mapStyle"
                  @load="mapLoaded"
                >
                  <MglMarker
                    v-if="marker"
                    anchor="bottom"
                    color="#9652ff"
                    :coordinates="marker.coordinates"
                  ></MglMarker>

                  <MglGeocoderControl
                    :accessToken="accessToken"
                    :mapboxgl="mapboxgl"
                    :marker="false"
                    @result="selectedItem"
                  />
                </MglMap>
                <v-card-actions>
                  <div class="flex-grow-1"></div>

                  <v-btn v-show="marker != null" color="error" text @click="removePin"
                    >{{ this.$t("common.deletePin") }}
                  </v-btn>
                  <v-btn color="primary" @click="saveNewPoint">{{ $t("common.save") }} </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <div class="d-flex flex-row align-center mt-4">
            <v-icon>{{ hotel ? "mdi-location-enter" : "mdi-calendar" }} </v-icon>
            <h4 class="ml-4" style="width: 80px">
              {{ hotel ? this.$t("common.checkIn") : this.$t("common.date") }}
            </h4>
            <DatePickerField v-model="eventDate" :label="$t('common.date')" @input="dateChanged" />
            <v-icon class="ml-4">mdi-clock-outline</v-icon>
            <vue-timepicker
              class="ml-2"
              fixed-dropdown-button
              format="h:mm a"
              :placeholder="$t('common.time.time')"
              input-width="160px"
              v-model="eventTime"
              manual-input
            ></vue-timepicker>
            <!-- close-on-complete -->
            <v-icon v-if="!hotel" class="ml-4">mdi-timer</v-icon>
            <vue-timepicker
              v-if="!hotel"
              class="ml-2"
              fixed-dropdown-button
              :placeholder="$t('common.duration')"
              input-width="160px"
              v-model="eventDuration"
              manual-input
              close-on-complete
            ></vue-timepicker>
          </div>
          <div v-if="hotel" class="d-flex flex-row align-center mt-4">
            <v-icon> mdi-location-exit </v-icon>
            <h4 class="ml-4" style="width: 80px">{{ $t("common.checkout") }}</h4>
            <DatePickerField :label="$t('common.date')" v-model="checkOutDate" />
            <v-icon class="ml-4">mdi-clock-outline</v-icon>
            <vue-timepicker
              class="ml-2"
              fixed-dropdown-button
              format="h:mm a"
              :placeholder="$t('common.time.time')"
              input-width="160px"
              v-model="checkOutTime"
              manual-input
              close-on-complete
            ></vue-timepicker>
          </div>
          <div class="d-flex flex-row">
            <v-autocomplete
              :items="timeZones"
              v-model="timezone"
              item-text="city"
              :label="$t('itinerary.NewEvent.remoteTimeZone')"
              :rules="[rules.required]"
              return-object
              prepend-icon="mdi-map-clock"
            ></v-autocomplete>
            <v-checkbox
              color="primary"
              class="mb-4"
              v-model="newEvent.hide_date"
              :label="this.$t('itinerary.NewEvent.hiddeActivityTimeLabel')"
              :persistent-hint="true"
              :hint="this.$t('itinerary.NewEvent.hiddeActivityTimeHint')"
              style="margin-left: 120px; max-width: 300px"
            ></v-checkbox>
          </div>
          <v-text-field
            v-if="isRemote"
            prepend-icon="mdi-link"
            v-model="newEvent.meeting_url"
            :label="$t('itinerary.NewEvent.meetingUrl')"
            :rules="[rules.isUrl]"
          >
          </v-text-field>
          <div class="d-flex flex-row align-top mt-4">
            <div class="mt-2">
              <v-icon class="">mdi-account-group</v-icon>
            </div>
            <h4 class="mx-4 mt-2">{{ $t("common.attendance") }}</h4>
            <div>
              <v-btn-toggle
                v-model="invitedMode"
                persistent-hint
                mandatory
                hin
                rounded
                dense
                color="primary"
              >
                <v-btn v-for="type in privacy" :key="type.value" :value="type.value">{{
                  type.text
                }}</v-btn>
              </v-btn-toggle>
              <p>{{ privacyHint }}</p>
            </div>
          </div>
          <div class="d-flex flex-row align-center mt-4" v-if="invitedMode == 3">
            <v-icon>mdi-format-list-bulleted</v-icon>
            <h4 class="mx-4">
              {{ $t("itinerary.NewEvent.selectedSubgroups") }}
            </h4>
            <v-select
              multiple
              v-model="subgroups"
              :items="allSubgroups"
              item-text="name"
              item-value="id"
              :label="this.$t('navbar.menu.subgroups')"
              single-line
            ></v-select>
          </div>
          <div class="d-flex flex-row align-center mt-4" v-if="invitedMode == 4">
            <v-icon>mdi-format-list-bulleted</v-icon>
            <h4 class="mx-4">{{ $t("common.selectedUsers") }}</h4>
            <v-select
              class="ml-6"
              multiple
              v-model="invitedUsers"
              :items="allUsers"
              item-text="name"
              item-value="id"
              :label="this.$t('common.attendance')"
              single-line
            ></v-select>
          </div>
          <div class="d-flex flex-row align-center mt-4">
            <v-icon> mdi-bell </v-icon>
            <h4 class="mx-4">{{ $t("common.notifications") }}</h4>
            <v-checkbox
              dense
              color="primary"
              v-model="newEvent.alarm"
              :label="this.$t('common.alarm')"
            ></v-checkbox>
            <v-select
              class="ml-4"
              dense
              :items="reminders"
              :label="this.$t('common.remindersHint')"
              hide-details
              v-model="newEvent.reminder"
            ></v-select>
          </div>
          <div class="d-flex flex-row align-center mt-4">
            <v-icon>mdi-chart-donut</v-icon>
            <h4 class="mx-4">Data</h4>

            <v-checkbox
              v-if="!newEvent.hide_date && !isRemote"
              color="primary"
              :persistent-hint="true"
              v-model="newEvent.attendance"
              :hint="this.$t('itinerary.NewEvent.attendanceHint')"
              :label="this.$t('itinerary.NewEvent.attendanceLabel')"
              :rules="[
                !newEvent.attendance ||
                  (newEvent.attendance && this.newEvent.location.coordinates != null) ||
                  this.$t('common.rules.attendance'),
              ]"
            ></v-checkbox>

            <v-checkbox
              v-if="!newEvent.hide_date"
              class="ml-4"
              color="primary"
              persistent-hint
              v-model="newEvent.feedback"
              :hint="this.$t('common.feedbackFinal')"
              :label="this.$t('common.feedBackLabel')"
              :rules="[
                !newEvent.feedback ||
                  (newEvent.feedback && eventDuration != null) ||
                  this.$t('common.rules.feedbackFinalDuration'),
              ]"
            ></v-checkbox>
          </div>
          <div class="text-right">
            <p v-if="feedback" class="red--text text-right mr-2">
              {{ feedback }}
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">{{ $t("common.cancel") }}</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveEvent">{{
            this.$t("common.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import DragAndDrop from "@/components/Base/DragAndDrop";
import DatePickerField from "@/components/Base/DatePickerField";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
// import TimePickerField from "@/components/Base/TimePickerField";
import _ from "lodash";

import { MglMap, MglMarker } from "v-mapbox";
import MglGeocoderControl from "@geospoc/v-mapbox-geocoder";
import Mapbox from "mapbox-gl";

import moment from "moment-timezone";
import mbAPI from "@/APIS/mapbox-api";
import firestore from "@/firebase/firestore";
import storage from "@/firebase/storage";
import { uuid } from "vue-uuid";
import timezones from "@/assets/CitiesAndTimeZones.json";
import reminders from "@/assets/reminders";
import { quillEditor } from "vue-quill-editor";

// import theme style
// eslint-disable-next-line import/no-extraneous-dependencies
import "quill/dist/quill.snow.css";

export default {
  name: "NewEvent",
  props: ["hotel", "value", "editEvent"],
  components: {
    DragAndDrop,
    MglMap,
    MglMarker,
    MglGeocoderControl,
    DatePickerField,
    VueTimepicker,
    quillEditor,
  },
  data(a) {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["clean"],
            ["link"],
          ],
        },
        theme: "snow",
        placeholder: a.$t("common.description"),
      },
      mapDialog: false,
      invitedMode: 2,
      newEvent: {
        description: "",
        privacy: 2,
        reminder: null,
        alarm: true,
        feedback: false,
        attendance: false,
        hotel: false,
        location: { address: null, coordinates: null },
        // time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        hide_date: false,
        // virtual: false,
      },
      mapCenter: [0, 0],
      mapZoom: 0,
      marker: null,
      formValid: false,
      saving: false,
      timezone: null,
      image: null,
      pdf: null,
      savedPDF: null,
      currentImage: null,
      city: null,
      recycledImagePath: null,

      eventDate: new Date().toISOString().substr(0, 10),
      eventTime: {},
      eventDuration: {},
      hasDateModified: false,

      checkOutDate: new Date().toISOString().substr(0, 10),
      checkOutTime: null,

      invitedUsers: [],
      subgroups: [],
      feedback: null,

      reminders: reminders.options(this.$i18n),
      privacy: [
        {
          value: 2,
          text: this.$i18n.t("common.privacy.everyone.text"),
          hint: this.$i18n.t("common.privacy.everyone.hint"),
        },
        {
          value: 1,
          text: this.$i18n.t("common.privacy.optional.text"),
          hint: this.$i18n.t("common.privacy.optional.hint"),
        },
        {
          value: 3,
          text: this.$i18n.t("common.privacy.subgroups.text"),
          hint: this.$i18n.t("common.privacy.subgroups.hint"),
        },
        {
          value: 4,
          text: this.$i18n.t("common.privacy.custom.text"),
          hint: this.$i18n.t("common.privacy.custom.hint"),
        },
      ],
      rules: {
        required: (value) => !!value || "Required.",
        isUrl: (value) => {
          const regex =
            /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
          return !value || regex.test(value) || "Please enter a valid Url";
        },
      },

      isRemote: false,
      usersMenu: false,
    };
  },
  watch: {
    editEvent(newEvent) {
      console.log("isEditingEvent");
      if (newEvent) {
        this.setupEditEvent(newEvent);
      }
    },
  },
  methods: {
    dateChanged(date) {
      const dateObj = moment(date, "YYYY-MM-DD").toDate().setHours(10, 0, 0, 0);
      this.hasDateModified = true;
      if (this.timezone == null) {
        const city = this.cities.find((c) => {
          const cityArr = moment(c.arrival_date, "YYYY-MM-DD").toDate().setHours(0, 0, 0, 0);
          const cityDep = moment(c.departure_date, "YYYY-MM-DD").toDate().setHours(23, 59, 59, 999);

          return dateObj >= cityArr && dateObj <= cityDep;
        });
        if (city) {
          this.city = city;
          this.cityChanged(city);
        }
      }
    },
    onPDFPicked(e) {
      const { files } = e.target;
      if (!files || files.length === 0) return;
      [this.pdf] = files;
    },
    clearPDF() {
      if (this.$props.editEvent) {
        this.savedPDF = null;
        this.newEvent.files = { pdf: null };
      } else {
        this.pdf = null;
        this.$refs.pdf.value = "";
      }
    },
    cityChanged(city) {
      this.newEvent.location.city = city.id;
      console.log(city);
      this.timezone = this.timeZones.find((tz) => tz.timezone === city.time_zone);
      if (this.mapCenter[0] === 0) {
        this.mapCenter = [city.center.longitude, city.center.latitude];
        console.log(this.mapCenter);
        this.mapZoom = 10;
      }
      if (!this.hasDateModified) {
        this.eventDate = city.arrival_date;
      }
    },
    onEditorReady(quill) {
      if (this.$props.editEvent) {
        if (this.newEvent.quill_description) {
          quill.setContents(JSON.parse(this.newEvent.quill_description).ops);
        } else {
          quill.setText(this.newEvent.description);
        }
      } else {
        const now = moment(this.$store.state.trip.trip.start_date.toDate()).tz("UTC");
        this.eventDate = now.format("YYYY-MM-DD");
        this.checkOutDate = now.format("YYYY-MM-DD");
      }
    },
    setupEditEvent(event) {
      console.log("setupEditEvent(,", event);
      this.hasDateModified = true;
      this.newEvent = {
        name: event.name,
        reminder: event.reminder,
        description: event.description,
        quill_description: event.quill_description,
        alarm: event.alarm,
        location: _.clone(event.location),
        privacy: event.privacy,
        feedback: event.feedback,
        attendance: event.attendance,
        // time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        hotel: event.hotel,
        hide_date: event.hide_date ?? false,
      };

      const imageUrl = this.$store.state.imageUrls[event.id];
      if (imageUrl) {
        this.currentImage = imageUrl;
      } else if (event.files && event.files.header && !event.files.header.includes("/")) {
        this.currentImage = event.files.header;
      }
      if (event.files && event.files.pdf) {
        const pdfName = event.files.pdf.split("/").pop().split("-");
        pdfName.shift();
        this.savedPDF = pdfName.join("-");
      }
      if (event.location.coordinates) {
        this.newEvent.location.coordinates = {
          lat: event.location.coordinates.latitude,
          long: event.location.coordinates.longitude,
        };

        this.mapCenter = [
          this.newEvent.location.coordinates.long,
          this.newEvent.location.coordinates.lat,
        ];
        this.mapZoom = 13;
        this.marker = {
          address: event.location.address,
          wiki_code: event.location.wiki_code,
          coordinates: this.mapCenter,
        };
      }
      const date = event.location.date.toDate();
      let momentDate;
      console.log("edit event", date);
      if (this.newEvent.location.city) {
        this.city = this.cities.find((c) => c.id === this.newEvent.location.city);
      }

      if (event.remote_tz) {
        this.isRemote = true;
        this.newEvent.remote_tz = event.remote_tz;
        momentDate = moment(date).tz(this.newEvent.remote_tz);
        if (event.meeting_url) {
          this.newEvent.meeting_url = event.meeting_url;
        }
        this.timezone = this.timeZones.find((t) => t.timezone === event.remote_tz);
      } else {
        momentDate = moment(date).tz(this.newEvent.location.time_zone || "UTC");
        if (this.newEvent.location.time_zone) {
          if (this.city == null) {
            this.city = this.cities.find((c) => c.time_zone === this.newEvent.location.time_zone);
          }
          this.timezone = this.timeZones.find(
            (tz) => tz.timezone === this.newEvent.location.time_zone,
          );
          if (this.city && this.mapCenter[0] === 0) {
            console.log(this.city);
            this.mapCenter = [this.city.center.longitude, this.city.center.latitude];
          }
        }
      }

      this.eventDate = momentDate.format("YYYY-MM-DD");
      this.eventTime = {
        h: momentDate.format("h"),
        mm: momentDate.format("mm"),
        a: momentDate.format("a"),
      };

      this.invitedMode = this.newEvent.privacy;
      if (event.privacy === 3) {
        this.invitedUsers = Object.keys(event.users || {});
        this.subgroups = Object.keys(event.subgroups || {});
        if (event.users) {
          this.invitedMode = 4;
        }
      }
      if (event.duration) {
        if (!event.hotel) {
          this.eventDuration = {
            HH: `0${Math.trunc(event.duration / 60)}`.slice(-2),
            mm: `0${event.duration % 60}`.slice(-2),
          };
        } else {
          const durMoment = moment(date)
            .add(event.duration, "minutes")
            .tz(this.newEvent.location.time_zone || "UTC");
          this.checkOutDate = durMoment.format("YYYY-MM-DD");
          this.checkOutTime = {
            h: durMoment.format("h"),
            mm: durMoment.format("mm"),
            a: durMoment.format("a"),
          };
        }
      }
    },
    saveNewPoint() {
      this.mapDialog = false;
      if (this.marker) {
        this.newEvent.location.coordinates = false;
        this.newEvent.location.address = this.marker.address;
        this.newEvent.location.wiki_code = this.marker.wiki_code;
        this.newEvent.location.coordinates = {
          lat: this.marker.coordinates[1],
          long: this.marker.coordinates[0],
        };
        this.city = { id: this.marker.city };
        // marker coordinates 0-long 1-lat
        mbAPI
          .getTimezone(this.marker.coordinates[1], this.marker.coordinates[0])
          .then((timezone) => {
            this.newEvent.location.time_zone = timezone;
            this.timezone = this.timeZones.find((tz) => tz.timezone === timezone);
          });
      }
    },
    selectedItem(event) {
      console.log("selected item");
      console.log(event.result);
      // center 0-long 1-lat
      const wikiCode =
        event.result.properties.wikiData ||
        event.result.context.find((context) => context.wikidata).wikidata;

      this.marker = {
        coordinates: event.result.center,
        address: event.result.place_name,
        wiki_code: wikiCode,
      };
    },
    closeDialog() {
      this.$emit("closed");
    },
    mapLoaded(payload) {
      console.log("map loaded!");

      //  if (this.newEvent.location.coordinates) {
      //   this.marker = {
      //     coordinates: [
      //       this.newEvent.location.coordinates.long,
      //       this.newEvent.location.coordinates.lat,
      //     ],
      //     address: this.newEvent.location.address,
      //   };
      // }

      payload.map.on("click", (e) => {
        const { lngLat } = e;
        console.log("clicked on", lngLat);

        this.marker = { coordinates: [lngLat.lng, lngLat.lat] };

        mbAPI.reverseGeocode(lngLat.lat, lngLat.lng).then((result) => {
          console.log("reversGeocode->", result);

          this.$set(this.marker, "city", result.city);
          this.$set(this.marker, "address", result.name);
          this.$set(this.marker, "wiki_code", result.wiki_code);
        });
      });
    },

    removePin() {
      console.log("removing pin");
      this.marker = null;
      this.$delete(this.newEvent.location, "coordinates");
      this.$delete(this.newEvent.location, "address");
      this.$delete(this.newEvent.location, "wiki_code");
      this.$delete(this.newEvent.location, "time_zone");
    },
    toBoolArray(object) {
      if (!object) return null;
      return object.reduce((obj, id) => {
        // eslint-disable-next-line no-param-reassign,indent
        obj[id] = true;
        return obj;
      }, {});
    },
    saveEvent() {
      if (!this.$refs.form.validate()) {
        this.feedback = this.$t("itinerary.NewEvent.feedBack1");
        return;
      }
      console.log(this.eventTime);
      if (!this.eventTime || !this.eventTime.h || !this.eventTime.mm) {
        this.feedback = this.$t("itinerary.NewEvent.feedbackTime");
        return;
      }
      if (!this.eventTime.a) {
        this.feedback = this.$t("itinerary.NewEvent.feedbackTimeAMPM");
        return;
      }

      this.feedback = null;

      const isoTime = `${this.eventTime.h}:${this.eventTime.mm} ${this.eventTime.a.toLowerCase()}`;
      const isoDate = `${this.eventDate} ${isoTime}`;
      console.log(isoDate);

      const utc = moment(isoDate, "YYYY-MM-D h:mm a");

      const localDate = utc.toDate();

      if (this.isRemote) {
        this.newEvent.remote_tz = this.timezone.timezone;

        const tzDifference =
          moment.tz.zone(this.timezone.timezone).utcOffset(localDate.getTime()) -
          localDate.getTimezoneOffset();

        this.newEvent.location.date = new Date(localDate.getTime() + tzDifference * 60 * 1000);
      } else {
        this.newEvent.time_zone = "UTC";
        this.newEvent.location.time_zone = this.timezone.timezone;
        const offset = moment.tz.zone(this.timezone.timezone).utcOffset(localDate.getTime());
        const tzDifference = offset - localDate.getTimezoneOffset();
        this.newEvent.location.date = new Date(localDate.getTime() + tzDifference * 60 * 1000);
        // this.newEvent.location.date = new Date(
        //   localDate.getTime() - localDate.getTimezoneOffset() * 60 * 1000,
        // );
      }
      this.newEvent.privacy = Math.min(this.invitedMode, 3);
      const isEdit = this.$props.editEvent;
      if (this.$props.hotel) {
        this.newEvent.hotel = true;
        if (!this.checkOutTime) {
          this.feedback = this.$t("itinerary.NewEvent.feedBack2");
          return;
        }
        const checkOutStr = `${this.checkOutDate} ${this.checkOutTime.h}:${
          this.checkOutTime.mm || 0
        } ${this.checkOutTime.a.toLowerCase()}`;

        const checkOut = moment(checkOutStr, "YYYY-MM-D h:mm a").toDate();

        const duration = (checkOut.getTime() - localDate.getTime()) / 60000;
        if (duration < 0) {
          this.feedback = this.$t("itinerary.NewEvent.feedBack2");
          return;
        }
        this.newEvent.duration = duration;
      } else if (this.eventDuration.mm || this.eventDuration.HH) {
        console.log(this.eventDuration);
        const durMinutes =
          parseInt(this.eventDuration.mm || 0, 10) + parseInt(this.eventDuration.HH || 0, 10) * 60;
        console.log("this eventt has durattion", durMinutes);

        if (durMinutes > 0) {
          this.newEvent.duration = durMinutes;
        }
      } else if (isEdit) {
        this.newEvent.duration = firestore.fieldDelete();
      }
      const tripId = this.$store.getters.currentTripId;
      this.newEvent.location.coordinates = firestore.getGeo(this.newEvent.location.coordinates);

      if (this.newEvent.privacy === 3) {
        if (
          (this.subgroups == null || this.subgroups.length === 0) &&
          (this.invitedUsers == null || this.invitedUsers.length === 0)
        ) {
          this.feedback = this.$t("itinerary.NewEvent.feedBack3");
          return;
        }
        if (this.invitedMode === 3) {
          this.newEvent.subgroups = this.toBoolArray(this.subgroups);
          if (isEdit) {
            this.newEvent.users = firestore.fieldDelete();
          }
        } else {
          if (isEdit) {
            this.newEvent.subgroups = firestore.fieldDelete();
          }
          this.newEvent.users = this.toBoolArray(this.invitedUsers);
        }
      }
      this.saving = true;

      if (this.recycledImagePath) {
        const files = this.newEvent.files || {};
        files.header = this.recycledImagePath;
        this.newEvent.files = files;
      }

      this.newEvent.quill_description = JSON.stringify(
        this.$refs.myQuillEditor.quill.getContents(),
      );
      this.newEvent.description = this.$refs.myQuillEditor.quill.getText();
      let id;
      if (isEdit) {
        id = this.$props.editEvent.id;
      }
      console.log("saving new event", this.newEvent);
      firestore
        .writeTrackedDocument(tripId, "events", this.newEvent, id)
        .then((docRef) => {
          if (docRef) {
            id = docRef.id;
          }

          console.log("Document written with ID: ", id);

          if (this.image || this.pdf) {
            const saveTwice = this.imageUrl != null && this.pdf != null;
            let savedOnce = false;
            const fileSaved = () => {
              if (!saveTwice || (saveTwice && savedOnce)) {
                this.saving = false;
                this.closeDialog();
              } else if (saveTwice) {
                savedOnce = true;
              }
            };

            if (this.image) {
              console.log("saving image file");
              const name = `${uuid.v4()}.${this.image.name.split(".").pop().toLowerCase()}`;
              const firPath = `groups/${tripId}/images/${name}`;
              console.log(firPath);
              storage.uploadFile(this.image, firPath).then((snapshot) => {
                console.log("Uploaded a blob or file!", snapshot);
                firestore.writeTrackedDocument(
                  tripId,
                  "events",
                  {
                    "files.header": firPath,
                  },
                  id,
                );
                fileSaved();
              });
            }
            if (this.pdf) {
              console.log("saving pdf file");
              const name = `${uuid.v4().replaceAll("-", "")}-${this.pdf.name}`;
              const firPath = `groups/${tripId}/files/${name}`;
              console.log(firPath);
              storage.uploadFile(this.pdf, firPath).then((snapshot) => {
                console.log("Uploaded a blob or file!", snapshot);
                firestore.writeTrackedDocument(
                  tripId,
                  "events",
                  {
                    "files.pdf": firPath,
                  },
                  id,
                );
                fileSaved();
              });
            }
            return;
          }
          console.log("no image, exit");
          this.saving = false;
          this.closeDialog();
        })
        .catch((error) => {
          this.feedback = error.message;
          this.saving = false;
          console.error("Error adding document: ", error);
        });
    },
  },
  computed: {
    cities() {
      return Object.values(this.$store.state.trip.cities).sort((a, b) => {
        if (!a.arrival_date || !b.arrival_date) return 0;
        return a.arrival_date < b.arrival_date ? -1 : 1;
      });
    },
    timeZones() {
      return timezones;
    },
    mapboxgl() {
      return Mapbox;
    },
    accessToken() {
      return mbAPI.accessToken;
    },
    mapStyle() {
      return mbAPI.mapStyle;
    },

    privacyHint() {
      return this.privacy.filter((item) => item.value === this.invitedMode)[0].hint;
    },
    allUsers() {
      return this.$store.getters.allUsers;
    },
    allSubgroups() {
      const subgroupsIds = Object.keys(this.$store.state.trip.subgroups);
      const subgroupsAll = this.$store.state.trip.subgroups;

      return subgroupsIds.map((id) => subgroupsAll[id]);
    },
  },
};
</script>

<style >
.mgl-map-wrapper {
  height: 100%;
  position: relative;
  width: 100%;
}
.mgl-map-wrapper .mapboxgl-map {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
/* .editor-container {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
} */

.editor {
  height: calc(100% - 44px);
  /* background-color: red; */
  /* added these styles */
  flex: 1;
  /* overflow-y: auto; */
  width: 100%;
}
</style>

<style >
.vue__time-picker .display-time {
  border: none !important;
  border-bottom: 1px solid #949494 !important;
}
.vue__time-picker .dropdown .active {
  background-color: var(--v-primary-base) !important;
}
</style>
